// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
// @ts-ignore
import { _LocaleContainer } from './locale';
export function i18nProvider(container: Element) {
  return React.createElement(_LocaleContainer, null, container);
}
